import { render, staticRenderFns } from "./H5Details.vue?vue&type=template&id=2508a1b5&scoped=true&"
import script from "./H5Details.vue?vue&type=script&lang=js&"
export * from "./H5Details.vue?vue&type=script&lang=js&"
import style0 from "./H5Details.vue?vue&type=style&index=0&id=2508a1b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508a1b5",
  null
  
)

export default component.exports